import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import CoachList from '../CoachList';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.light};
`;

const CoachContainer = ({ onItemClick, clientToken, clubId }) => (
  <Container>
    <CoachList onItemClick={onItemClick} clientToken={clientToken} clubId={clubId} />
  </Container>
);

CoachContainer.propTypes = {
  clientToken: PropTypes.string.isRequired,
  clubId: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired
};

export default CoachContainer;



// WEBPACK FOOTER //
// ./src/components/CoachContainer/CoachContainer.jsx